<div class="bg-white rounded mb-3">
  <div class="border-bottom border-2">
    <div class="px-4">
      <h3 class="pt-2">{{ editMode ? "Edit Bill service" : "Create Bill Service" }}</h3>
    </div>
  </div>
  <div class="p-4">
    <form *ngIf="manageBillServiceForm" [formGroup]="manageBillServiceForm" (submit)="onSubmit()">
      <div class="row mb-3">
        <div class="col-md-12">
          <app-image [fieldObject]="controllers['image']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['image'].fieldName)" [isUpdate]="editMode"></app-image>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <label>Service Name <span class="text-danger">*</span></label>
          <input class="form-control" type="text" formControlName="name">
          <div class="alert alert-danger" *ngIf="formValidator.formErrors.name">
            {{ formValidator.formErrors.name }}
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4 ">
          <label>Bill Category <span class="text-danger">*</span></label>
          <ngx-select-dropdown  formControlName="categoryId" [options]="categories" [config]="config"></ngx-select-dropdown>

          <!-- <select formControlName="categoryId" class="form-control">
            <option disabled value="null" selected>Choose Bill Category</option>
            <option *ngFor="let category of categories" [value]="category.ID">{{ category.name }}</option>
          </select> -->
          <div class="alert alert-danger" *ngIf="formValidator.formErrors.categoryId">
            {{ formValidator.formErrors.categoryId }}
          </div>
        </div>
        <div class="col-md-4 ">
          <label> Bill Provider <span class="text-danger">*</span> </label>
          <ngx-select-dropdown  formControlName="providerId" [options]="providers" [config]="config"></ngx-select-dropdown>

          <!-- <select formControlName="providerId" class="form-control">
            <option disabled value="null" selected>Assign Provider</option>
            <option *ngFor="let provider of providers" [value]="provider.ID">{{ provider.name }}</option>
          </select> -->
          <div class="alert alert-danger" *ngIf="formValidator.formErrors.providerId">
            {{ formValidator.formErrors.providerId }}
          </div>
        </div>
        <div class="col-md-4 ">
          <label> Biller Service <span class="text-danger">*</span></label>
          <ngx-select-dropdown  formControlName="billerService" [options]="billerServices" [config]="config"></ngx-select-dropdown>
          <div class="alert alert-danger" *ngIf="formValidator.formErrors.billerService">
            {{ formValidator.formErrors.billerService }}
          </div>
        </div>
        <div class="cardbg-white my-3">
          <div class="row">
            <div class="col-md-4 ">
              <label>CashBack<span class="text-danger">*</span></label>
              <select formControlName="cashBackEnable" class="form-control">
                <option value="false" selected>disabled</option>
                <option value="true">enabled</option>
              </select>
              <div class="alert alert-danger" *ngIf="formValidator.formErrors.cashBackEnable">
                {{ formValidator.formErrors.cashBackEnable }}
              </div>
            </div>
            <div class="col-md-4">
              <label>Amount<span class="text-danger">*</span></label>
              <input class="form-control" type="number" formControlName="cashBackAmount">
              <div class="alert alert-danger" *ngIf="formValidator.formErrors.cashBackAmount">
                {{ formValidator.formErrors.cashBackAmount }}
              </div>
            </div>
            <div class="col-md-4 ">
              <label>Amount Type<span class="text-danger">*</span></label>
              <select formControlName="cashBackPercentage" class="form-control">
                <option disabled value="null" selected>select Amount type</option>
                <option  *ngFor="let type of cashBackAmountTypes" [value]="type.value">{{ type.name }}
                </option>
              </select>
              <div class="alert alert-danger" *ngIf="formValidator.formErrors.cashBackPercentage">
                {{ formValidator.formErrors.cashBackPercentage }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary col-auto" type="submit" [disabled]="manageBillServiceForm.invalid">
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
